import { createReducer } from 'typesafe-actions';
import { purge } from '../auth/actions';
import {
  getProposalDetails,
  getBilletProposal,
  getLinhaDigitavelProposalBillet,
} from './actions';

const INITIAL_STATE: ProposalState = {
  list: [],
  error: '',
  billet: '',
  billetLine: { nnumero: '', linhaDigitavel: '' } as GQL.IBillet,
};

const proposalReducer = createReducer(INITIAL_STATE)
  .handleAction(purge, () => INITIAL_STATE)
  .handleAction(getProposalDetails.success, (state, action) => ({
    ...state,
    list: action.payload,
  }))
  .handleAction(getProposalDetails.failure, (state, action) => ({
    ...state,
    error: action.payload,
  }))
  .handleAction(getBilletProposal.success, (state, action) => ({
    ...state,
    billet: action.payload,
  }))
  .handleAction(getBilletProposal.failure, (state, action) => ({
    ...state,
    billet: '',
    error: action.payload,
  }))
  .handleAction(getLinhaDigitavelProposalBillet.success, (state, action) => ({
    ...state,
    billetLine: action.payload,
  }))
  .handleAction(getLinhaDigitavelProposalBillet.failure, (state, action) => ({
    ...state,
    billetLine: INITIAL_STATE.billetLine,
    error: action.payload,
  }));

export default proposalReducer;
